const s = {
  name: "Coffee",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M19,0v1.2c0,2.1-0.8,4.1-2.3,5.5C15.6,7.8,15,9.3,15,10.8V12h-2v-1.2c0-2.1,0.8-4.1,2.3-5.5
			C16.4,4.2,17,2.7,17,1.2V0H19z"/>
		<path class="st0" d="M34,14H6v10c0,7.7,6.3,14,14,14H0v2h40v-2H20c7,0,12.9-5.2,13.9-12H34c3.3,0,6-2.7,6-6c0-1.7-0.7-3.2-1.7-4.2
			l0,0C37.2,14.7,35.7,14,34,14v2c1.1,0,2.1,0.4,2.8,1.2c0.7,0.7,1.2,1.7,1.2,2.8c0,2.2-1.8,4-4,4V14z M8,24v-8h24v8
			c0,6.6-5.4,12-12,12S8,30.6,8,24z"/>
		<path class="st0" d="M25,1.2V0h-2v1.2c0,1.5-0.6,3-1.7,4.1C19.8,6.8,19,8.8,19,10.8V12h2v-1.2c0-1.5,0.6-3,1.7-4.1
			C24.2,5.2,25,3.2,25,1.2z"/>
		<path class="st0" d="M31,0v1.2c0,2.1-0.8,4.1-2.3,5.5C27.6,7.8,27,9.3,27,10.8V12h-2v-1.2c0-2.1,0.8-4.1,2.3-5.5
			C28.4,4.2,29,2.7,29,1.2V0H31z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Coffee
};
